import { render, staticRenderFns } from "./adminForm.vue?vue&type=template&id=ab47ada6&scoped=true&"
import script from "./adminForm.vue?vue&type=script&lang=js&"
export * from "./adminForm.vue?vue&type=script&lang=js&"
import style0 from "./adminForm.vue?vue&type=style&index=0&id=ab47ada6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab47ada6",
  null
  
)

export default component.exports